import { render, staticRenderFns } from "./UploadJuniorAuthorWorkDialog.vue?vue&type=template&id=52243afe"
import script from "./UploadJuniorAuthorWorkDialog.vue?vue&type=script&lang=js"
export * from "./UploadJuniorAuthorWorkDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadJuniorAuthorWorkDialog.vue?vue&type=style&index=0&id=52243afe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports